import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IconWrapper } from './Icon.styles';
import { getIcon } from './utils';
import { IconProps } from './types';

const Icon = ({ fill = 'black', type, size, onClick }: IconProps) => {
  return (
    <IconWrapper
      color={fill}
      size={size}
      data-testid="icon-wrapper"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={getIcon(type)} color="current" />
    </IconWrapper>
  );
};

export default Icon;
